var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{staticClass:"container pt-0 pb-0",attrs:{"app":"","flat":"","rounded":"","fixed":"","color":"background"}},[_c('div',[_c('div',{staticClass:"website-title"},[_c('span',{staticClass:"name"},[_vm._v("Luca")]),_vm._v(" Minotti")])])]),_c('v-main',[_c('Home')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }